/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type InvoiceDto } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/by-order/{orderId}
 */
export interface WithOrderItemRequestBuilder extends BaseRequestBuilder<WithOrderItemRequestBuilder> {
    /**
     * Returns every invoice raised against one order, in any status — an order invoiced in instalments has several. An order that has never been invoiced, or an order id that does not exist, returns an empty array rather than a 404. A customer sees only the invoices raised against their own customer number, so probing another customer's order id returns nothing rather than an error. For invoiced-versus-remaining quantities, call the order invoice summary endpoint instead.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithOrderItemRequestBuilderGetQueryParameters> | undefined) : Promise<InvoiceDto[] | undefined>;
    /**
     * Returns every invoice raised against one order, in any status — an order invoiced in instalments has several. An order that has never been invoiced, or an order id that does not exist, returns an empty array rather than a 404. A customer sees only the invoices raised against their own customer number, so probing another customer's order id returns nothing rather than an error. For invoiced-versus-remaining quantities, call the order invoice summary endpoint instead.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithOrderItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns every invoice raised against one order, in any status — an order invoiced in instalments has several. An order that has never been invoiced, or an order id that does not exist, returns an empty array rather than a 404. A customer sees only the invoices raised against their own customer number, so probing another customer's order id returns nothing rather than an error. For invoiced-versus-remaining quantities, call the order invoice summary endpoint instead.
 */
export interface WithOrderItemRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithOrderItemRequestBuilderUriTemplate = "{+baseurl}/api/invoices/by-order/{orderId}{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithOrderItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithOrderItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
